import React, { useState, useRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const SearchCondition = ({ onDateChange }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [calendarOpen, setCalendarOpen] = useState(false);
  const calendarRef = useRef(null);

  const handleDateChange = date => {
    setStartDate(date);
    // onDateChange가 함수인지 확인한 후 호출
    if (onDateChange && typeof onDateChange === 'function') {
      onDateChange(date);
    }
  };

  const handleClickOutside = event => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setCalendarOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className='flex items-center mt-[2%] mb-[1.6%] text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl'>
      <div className='w-full flex items-center'>
        <div
          htmlFor='searchCondition'
          className='w-[11%] change_h mr-[5%] bg-gray-300 page_center text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl'
        >
          조회조건
        </div>
        <span className='change_text mr-[3%] text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl'>일</span>
        <div className='relative w-[20%] change_h bg-yellow-300 flex items-center border-2 border-black'>
          <button
            className='w-full h-full flex items-center justify-between px-3 text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl bg-yellow-300'
            onClick={() => setCalendarOpen(!calendarOpen)}
          >
            <span className='flex-1 text-center'>{startDate ? startDate.toLocaleDateString() : ''}</span>
            <span className='absolute right-2 text-gray-700'>▼</span>
          </button>
          {calendarOpen && (
            <div
              ref={calendarRef}
              className='absolute top-full left-0 mt-2 bg-white border border-gray-300 p-2 rounded shadow-md'
            >
              <DatePicker selected={startDate} onChange={handleDateChange} inline />
            </div>
          )}
        </div>
        <button
          className='w-[5%] change_h bg-sky-500 absolute right-4 border-2 border-black text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl'
          onClick={() => onDateChange(startDate, true)}
        >
          조회
        </button>
      </div>
    </div>
  );
};

export default SearchCondition;
